import { createContext, useState } from 'react';

import { createStore } from 'jotai';

import { CartProvider } from '../cart/Cart.provider';
import { RouterProvider } from '../router/router.provider';
import type {
  ShopProviderContext as ShopProviderContextType,
  ShopProviderProps,
} from './provider.types';

const ShopProviderContext = createContext<ShopProviderContextType | undefined>(undefined);

const Provider = ({
  previewMode = false,
  children,
  router,
  isAddToCartAvailable = true,
  isBuyNowAvailable = true,
  isConsolidatedCheckoutEnabled = false,
  unavailabilityReasons,
  getStoreId,
  provider,
  isNPOStore = false,
  storeFrontOptions,
  notFoundRedirect,
}: ShopProviderProps) => {
  const [store] = useState(() => createStore());

  return (
    <RouterProvider router={router}>
      <ShopProviderContext.Provider
        value={{
          store,
          isAddToCartAvailable,
          isBuyNowAvailable,
          unavailabilityReasons,
          getStoreId,
          provider,
          isNPOStore,
          storeFrontOptions,
          notFoundRedirect,
          previewMode,
          isConsolidatedCheckoutEnabled,
        }}
      >
        {children}
      </ShopProviderContext.Provider>
      <CartProvider />
    </RouterProvider>
  );
};

export { Provider as ShopProvider, ShopProviderContext };
